export const removeHashTag = (string) => {
  if (string) {
    return string.replace(/#/g, '')

  } else {
    return string.replace(/#/g, '')

  }
}